export default function ClosedCaptioning() {
  return (
    <div
      className="ion-icon-closed-captioning"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<g>
		<path d="M0,64v384h512V64H0z M464,255.825c0.045,26.724-1.547,47.143-3.797,80.223S441,392.5,401.097,396.168
			C361.201,399.835,305.369,400.12,256,400c-49,0.12-105.198-0.165-145.094-3.832c-39.903-3.668-56.855-27.04-59.105-60.12
			s-3.841-53.499-3.796-80.223c-0.045-26.725,0.095-44.124,3.798-80.224s23.01-56.267,59.106-59.934S201.842,112,248.704,112
			c2.431,0,5.296,0,7.296,0c2.437,0,4.871,0,7.302,0c46.862,0,101.698,0,137.795,3.667s55.403,23.833,59.106,59.934
			S464.045,229.1,464,255.825z"/>
	</g>
	<g>
		<path d="M372,283.846v0.766c0,18.639-11.581,29.566-27.003,29.566c-15.418,0-25.808-12.309-27.284-29.566
			c0,0-1.335-9.078-1.335-27.298s1.546-29.759,1.546-29.759c2.711-19.473,12.188-29.566,27.607-29.566
			c15.367,0,27.584,13.262,27.584,33.388c0.023,0.086,0.01,0.624,0.01,0.624h51.541c0-25-6.309-47.556-18.92-61.746
			c-12.617-14.183-31.403-21.273-56.369-21.273c-12.483,0-23.93,1.654-34.33,4.942c-10.404,3.295-19.376,9.062-26.916,17.291
			c-7.545,8.234-13.397,19.254-17.555,33.059c-4.162,13.809-6.242,31.224-6.242,52.247c0,20.52,1.688,37.684,5.072,51.488
			c3.377,13.811,8.388,24.83,15.018,33.059c6.632,8.234,14.953,13.935,24.967,17.1c10.01,3.163,21.779,4.748,35.304,4.748
			c28.604,0,49.089-7.258,61.443-21.318C418.486,327.537,424.666,307,424.666,280H372C372,280,372,282.876,372,283.846z"/>
		<path d="M195,283.846v0.766c0,18.639-11.581,29.566-27.003,29.566c-15.418,0-25.808-12.309-27.284-29.566
			c0,0-1.335-9.078-1.335-27.298s1.546-29.759,1.546-29.759c2.711-19.473,12.188-29.566,27.607-29.566
			c15.367,0,27.584,13.262,27.584,33.388c0.023,0.086,0.01,0.624,0.01,0.624h51.541c0-25-6.309-47.556-18.92-61.746
			c-12.617-14.183-31.403-21.273-56.369-21.273c-12.483,0-23.93,1.654-34.33,4.942c-10.404,3.295-19.376,9.062-26.916,17.291
			c-7.545,8.234-13.397,19.254-17.555,33.059c-4.162,13.809-6.242,31.224-6.242,52.247c0,20.52,1.688,37.684,5.072,51.488
			c3.377,13.811,8.388,24.83,15.018,33.059c6.632,8.234,14.953,13.935,24.967,17.1c10.01,3.163,21.779,4.748,35.304,4.748
			c28.604,0,49.089-7.258,61.443-21.318C241.486,327.537,247.666,307,247.666,280H195C195,280,195,282.876,195,283.846z"/>
	</g>
</g>
</svg>
`,
      }}
    />
  )
}
